import styled from 'styled-components';

export const Container = styled.div`
  width: '600px';
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-top: 10px;
`;
